import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Seguradora } from "./seguradora.model";
import { apiName } from "./data.service";

@Injectable()
export class SeguradoraApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Seguradora, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Seguradora, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"nome","include":["pessoaJuridica"]};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":["pessoaJuridica"]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/shared/seguradora-api.service.ts
 **/